import { RegisterPaymentModal } from '@components'

import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { formatDate } from '../../../../../../utils'
import { useVatDeclarationsRegisterPeriodPaymentModal } from '../../context/vatDeclarationsRegisterPaymentModalContext'

interface ModalDetailsProps {
  currency: string
}

export const ModalDetails = ({ currency }: ModalDetailsProps): ReactElement => {
  const { t } = useTranslation()
  const {
    periodText,
    periodTotalAmountDue,
    paymentDate: selectedPaymentDate,
  } = useVatDeclarationsRegisterPeriodPaymentModal()
  const periodLabel = t('vat_declarations.register_payment_modal.details.vat_declaration') + ' - ' + periodText
  const paymentDate = formatDate(selectedPaymentDate, 'dd/MM/yyyy')

  return (
    <RegisterPaymentModal.DetailsList itemsInRow={5}>
      <RegisterPaymentModal.DetailItem itemColumnStart={1} itemColumnEnd={3} label="-">
        <Text>{periodLabel}</Text>
      </RegisterPaymentModal.DetailItem>
      <RegisterPaymentModal.DetailItem
        itemColumnStart={3}
        itemColumnEnd={4}
        label={t('vat_declarations.register_payment_modal.form.date_label')}
      >
        <Text>{paymentDate}</Text>
      </RegisterPaymentModal.DetailItem>
      <RegisterPaymentModal.DetailItem
        itemColumnStart={5}
        itemColumnEnd={6}
        label={t('vat_declarations.register_payment_modal.incl_vat')}
        labelAlignment="right"
      >
        <Text alignment="right">
          {periodTotalAmountDue} {currency}
        </Text>
      </RegisterPaymentModal.DetailItem>
    </RegisterPaymentModal.DetailsList>
  )
}
